import _extends from "@babel/runtime/helpers/extends";
import { colors } from '@argo/principles';
import React from 'react';
import IconBase from './IconBase';
const TrackerIcon = props => React.createElement(IconBase, _extends({}, props, {
  viewBox: "0 0 512 512",
  fillColor: colors.primary[props.color] || colors.neutral[props.color] || colors.action[props.color]
}), React.createElement("g", null, React.createElement("path", {
  d: "M434.553,99.616L270.892,426.938c-2.881,5.941-7.742,8.912-14.584,8.912c-0.81,0-2.161-0.18-3.871-0.54 c-3.781-0.81-6.752-2.791-9.092-5.761s-3.421-6.392-3.421-10.083V272.279H92.648c-3.781,0-7.112-1.17-10.083-3.421 c-2.971-2.341-4.861-5.311-5.761-9.092c-0.81-3.781-0.54-7.292,0.99-10.713c1.53-3.421,4.051-5.941,7.382-7.652L412.498,77.65 c2.251-1.17,4.681-1.8,7.382-1.8c4.591,0,8.462,1.62,11.523,4.861c2.521,2.431,4.141,5.311,4.771,8.822 S436.174,96.375,434.553,99.616z"
})));
TrackerIcon.displayName = 'TrackerIcon';
export default TrackerIcon;
//# sourceMappingURL=TrackerIcon.js.map